import polyfillSmoothScroll from './smooth-scroll';
import polyfillInteractionObserver from './intersection-observer';
import polyfillUrlSearchParams from './url-search-params-polyfill';

export default [
  ...polyfillSmoothScroll,
  ...polyfillUrlSearchParams,
  ...polyfillInteractionObserver,
];
